import { OrderControl } from '@usf/ngrx-order/lib/models/client/order-control';

/**
 * Utility function to find ec_appl_val for the given ec_sub_appl and ec_appl_key from order-control-state
 * @param array Array of OrderControl objects to search through
 * @param subAppl The ec_sub_appl value to match
 * @param applKey The ec_appl_key value to match
 * @param forceNumberVal Optional flag to force return value as number
 * @returns The matching ec_appl_val or null if not found. If forceNumberVal is true, returns 0 for null/NaN values
 */
export const findEcApplVal = (
  array: OrderControl[],
  subAppl: string,
  applKey: string,
  forceNumberVal?: boolean,
): any => {
  const foundItem = array.find(
    item => item.ec_sub_appl === subAppl && item.ec_appl_key === applKey,
  );
  if (forceNumberVal) {
    const value = foundItem ? Number(foundItem.ec_appl_val) : 0;
    return isNaN(value) ? 0 : value;
  }
  return foundItem ? foundItem.ec_appl_val : null;
};
